"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locale = void 0;
let currentLocale = 'es';
const locale = {
    getLocale() {
        return currentLocale;
    },
    setLocale(newLocale) {
        currentLocale = newLocale;
    },
};
exports.locale = locale;
Object.freeze(locale);
//# sourceMappingURL=locale.js.map